import React from "react";
import {Image} from 'react-bootstrap';

import "./EnterpriseNews.css";

import icon_enterprise_news from "../../asset/images/icon_enterprise_news.webp";
import icon_select from "../../asset/images/icon_select.png";
import img_suopu from "../../asset/images/img_suopu.png";
import btn_02 from "../../asset/images/btn_02.svg";

// 企业动态
class EnterpriseNews extends React.Component {
  render() {
    return (
      <div className="enterprise_news" id="enterprise_news">
        <div className="news_up">
          <Image src={icon_enterprise_news} className="news_ico" />
          <div className="news_getway">
            <div className="news_getway_row">
              <Image src={icon_select} className="news_getway_icon" />
              <div className="news_getway_title"><a href="#enterprise_news">企业动态</a></div>
            </div>
            <div className="news_getway_line"></div>
            <div className="news_getway_row">
              <div className="news_getway_round"></div>
              <div className="news_getway_title_two"><a href="#industry">行业新闻</a></div>
            </div>
            <div className="news_getway_line"></div>
            <div className="news_getway_row">
              <div className="news_getway_round"></div>
              <div className="news_getway_title_two"><a href="#release">新闻公告</a></div>
            </div>
          </div>
        </div>
        <div className="news_down">
          <div className="news_down_left">
            <Image src={img_suopu} className="news_down_left_image" />
            <div className="news_down_left_title">
              镇江索普集团|正式签约
            </div>
            <div className="news_down_left_content">
              涵智博雅总经理黄晓东与镇江索普集团常务副总凌晨凌总就索普集团未来空压机节能改造及新型EMC模式进行了深入讨论并签订相关合作协议...
            </div>
            <Image className="news_down_btn2" src={btn_02} />
          </div>
          <div className="news_down_right">
            <div className="news_down_card">
              <div className="news_down_date">
                <div className="news_down_day">23</div>
                <div className="news_down_year">2020-12</div>
              </div>
              <div className="news_down_content">
                <div className="news_down_title">物联网与大数据息息相关？</div>
                <div className="news_down_paragraph">
                  针对物联网的分析研究，其主要涵盖感知层、网络层还有应用层。感知层包含识读器、二维码标签、传感器、终端等…...
                </div>
              </div>
            </div>
            <div className="news_down_card">
              <div className="news_down_date">
                <div className="news_down_day">29</div>
                <div className="news_down_year">2020-12</div>
              </div>
              <div className="news_down_content">
                <div className="news_down_title">进气阀科普篇</div>
                <div className="news_down_paragraph">
                  螺杆式空压机的进气阀是空压机的呼吸口，普通空气进入进气阀后到压缩机头，经过压缩而产生压缩气体….........
                </div>
              </div>
            </div>
            <div className="news_down_card">
              <div className="news_down_date">
                <div className="news_down_day">12</div>
                <div className="news_down_year">2021-1</div>
              </div>
              <div className="news_down_content">
                <div className="news_down_title">解析大数据</div>
                <div className="news_down_paragraph">
                  在人类社会的早期，民以食为天，数据的产生大多与商品，食物，土地等挂钩。旧石器时代的部落人民在树枝或骨头上刻下凹痕来记录日常…......
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EnterpriseNews
